"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fedopsLogger = void 0;
const fedops_logger_1 = require("@wix/fedops-logger");
const constants_1 = require("./constants");
exports.fedopsLogger = (0, fedops_logger_1.create)(constants_1.FEDOPS_LOGGER_ID);
//# sourceMappingURL=index.js.map